export default "__VITE_PUBLIC_ASSET__8912d839__"